import { render, staticRenderFns } from "./DigitSeparatorsLabel.vue?vue&type=template&id=1e380f1c&lang=pug"
import script from "./DigitSeparatorsLabel.vue?vue&type=script&lang=js"
export * from "./DigitSeparatorsLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports